<template>
  <DrawerVue :refreshDisplay="refreshDisplay">
    <v-container class="deletionWarning">
      <v-row>
        <v-col :cols="cols">
          <h1>
            {{ $t("messages.unDeleteUser") }}
          </h1>
        </v-col>
      </v-row>


      <v-row>
        <v-col>
          <v-btn
            large
            block
            flat
            class="primaryButton"
            @click="confirm()"
            ref="confirmButton"
          >
            <span>{{ $t("basics.confirm") }}</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </DrawerVue>
</template>

<script>
export default {
  name: "deletionWarning",

  props: ["refreshDisplay", "userData"],
  emits: ["confirm"],

  data() {
    return {};
  },

  methods: {
    confirm(){
      this.$emit("confirm")
    }
  },

  mounted() {},
};
</script>
